export default [
  {
    path: '/vistoria/:vistoriaId/veiculo-ambiente/:ambienteId/item',
    name: 'VeiculoItemList',
    component: () => import('./VeiculoItensList'),
    meta: {
      routerBack: '/vistoria/:vistoriaId/veiculo-ambiente',
      domain: 'itens',
      sidebar: false,
      title: 'Item do ambiente',
      icon: 'keyboard_backspace',
    },
    children: [
      {
        path: '/vistoria/:vistoriaId/veiculo-ambiente/:ambienteId/item-new',
        name: 'VeiculoItensForm',
        component: () => import('./ItensForm/VeiculoItensForm'),
        meta: {
          sidebar: false,
          routerBack: '/vistoria/:vistoriaId/ambiente/:ambienteId/item',
          domain: 'Itens',
          title: 'Novo item do ambiente',
          icon: 'keyboard_backspace',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/app/Veiculos/Vistoria/Ambiente/Itens/VeiculoItensRouter.js